import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { FARM_MAP_ROWS, FARM_ZONES } from './farmMapData';

function MapCell({ cell, activeZone, onZoneChange, canRecord, onShedClick }) {
  if (!cell) return null;

  if (cell.type === 'landmark') {
    return <div className="farm-map-cell farm-map-landmark">{cell.label}</div>;
  }

  const highlighted = activeZone === cell.zone;

  if (cell.type === 'test') {
    return (
      <button
        type="button"
        className={`farm-map-cell farm-map-test ${highlighted ? 'farm-map-cell-active' : ''}`}
        onClick={() => onZoneChange(activeZone === 'TEST' ? null : 'TEST')}
      >
        {cell.id}
      </button>
    );
  }

  const handleShedClick = () => {
    if (canRecord) {
      onShedClick?.(cell.id);
      return;
    }
    onZoneChange(activeZone === cell.zone ? null : cell.zone);
  };

  return (
    <button
      type="button"
      className={`farm-map-cell farm-map-shed ${highlighted ? 'farm-map-cell-active' : ''} ${canRecord ? 'farm-map-shed-recordable' : ''}`}
      onClick={handleShedClick}
    >
      {cell.id}
    </button>
  );
}

function toCell(value) {
  if (!value) return null;

  if (value === 'TEST') {
    return { type: 'test', id: 'TEST_FARM', zone: 'TEST' };
  }

  if (/^[ABC]\d+$/.test(value)) {
    return { type: 'shed', id: value, zone: value.charAt(0) };
  }

  return { type: 'landmark', label: value };
}

function renderCells(values, activeZone, onZoneChange, canRecord, onShedClick) {
  const items = Array.isArray(values) ? values : values ? [values] : [];

  return items.map((value) => {
    const cell = toCell(value);
    if (!cell) return null;

    return (
      <MapCell
        key={cell.id || cell.label}
        cell={cell}
        activeZone={activeZone}
        onZoneChange={onZoneChange}
        canRecord={canRecord}
        onShedClick={onShedClick}
      />
    );
  });
}

const SLOT_COLUMNS = ['a', 'landmark', 'bArea', 'center', 'cMain', 'cExt'];

const FarmMap = ({ activeZone, onZoneChange, canRecord, onShedClick }) => {
  const { t } = useTranslation();

  return (
    <div className="farm-map-panel">
      <div className="farm-zone-tabs">
        {FARM_ZONES.map((zone) => (
          <Button
            key={zone}
            type={activeZone === zone ? 'primary' : 'default'}
            size="large"
            onClick={() => onZoneChange(activeZone === zone ? null : zone)}
            className={`farm-zone-tab ${activeZone === zone ? 'farm-zone-tab-active' : ''}`}
          >
            {zone === 'TEST' ? t('home.map.test') : t('home.map.zone', { zone })}
          </Button>
        ))}
      </div>

      <div className="farm-map-scroll">
        <div className="farm-map-body">
          {FARM_MAP_ROWS.map((row, rowIndex) => (
            <div
              key={`row-${rowIndex}`}
              className={`farm-map-row${row.testRow ? ' farm-map-row-test' : ''}`}
            >
              {SLOT_COLUMNS.map((key) => (
                <div
                  key={key}
                  className={`farm-map-slot farm-map-col-${key}`}
                >
                  {renderCells(row[key], activeZone, onZoneChange, canRecord, onShedClick)}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FarmMap;
